import React from "react";
var __jsx = React.createElement;
import stl from "./SquareSlider.module.css";
import SingleSquareSlider from "./SingleSquareSlider";
import useIsMobile from "@hooks/useIsMobile";
import { useCMS } from "@hooks/useCMS";
var SquareSlider = function SquareSlider(props) {
  var _useCMS = useCMS(),
    urlHelper = _useCMS.urlHelper;
  var isMobile = useIsMobile();
  var bgColor = isMobile ? props === null || props === void 0 ? void 0 : props.bg_color_mobile : props === null || props === void 0 ? void 0 : props.bg_color;
  var cta = props.cta;
  var showCta = cta && cta.url && cta.text && (cta.display_mode === "all" || cta.display_mode === "desktop" && !isMobile || cta.display_mode === "mobile" && isMobile);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container,
    style: {
      backgroundColor: bgColor !== null && bgColor !== void 0 ? bgColor : "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", {
    className: stl.big
  }, props === null || props === void 0 ? void 0 : props.title), (props === null || props === void 0 ? void 0 : props.cards) && /*#__PURE__*/React.createElement("div", {
    className: stl.outterContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.cardsContainer
  }, props === null || props === void 0 ? void 0 : props.cards.map(function (card, index) {
    return /*#__PURE__*/React.createElement(SingleSquareSlider, {
      key: index,
      cardData: card
    });
  }))), showCta && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: urlHelper(cta.url),
    className: ["blueBtn", stl.partnersButton].join(" ")
  }, cta.text)))));
};
export default SquareSlider;